<template>	
<div class="headerbox">	
     <img :src = "userIcon" class="headerIcon" @click="toLogin()">	
</div>
</template>

<script>
	var userIcon
	var nickName
	export default {
	  name: 'userheader',	 
	  data(){
	  		return{			
	  		     userIcon,
                 nickName
	  		}  	 
		},
        created(){
			
			if (localStorage["isLogin"] == "0")
			{
				this.userIcon = require("@/assets/icon/user1.png")
			}
			else
			{
				this.userIcon = localStorage["userIcon"]
				this.userIcon = require("@/assets/icon/user2.png")
				this.nickName = localStorage["nickName"]
			}
			
		},
		methods:{
			submit(){
				alert("aaa")
			},
			toLogin(){
				if (localStorage["isLogin"] == "0")
				{					
					this.$router.push('/login')
				}
			}
		}
	  }
</script>
<style>
.headerIcon {
	width:36px;
	height:36px;
	border-radius:36px;
}
.headerbox {
	height:36px;
	vertical-align:middle;
}
</style>
